import React from "react";
import "../../App.css";
import DailyDSRReport from "../DailyDSRReport"

function DailyDSRReportPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("dsr-report")){
    return;}
  return (
    <div className="page-mr">
      <DailyDSRReport sessionObject={sessionObject} />
    </div>
  );
}

export default DailyDSRReportPage;
